module.exports = __webpack_public_path__ + "img/web.7f166402.jpg";